const KeySVG = ({ fill }) => {
  return (
    <svg fill={fill} xmlns="http://www.w3.org/2000/svg" width="150px" x="0px" y="0px" viewBox="0 0 512 512">
      <g>
        <g>
          <g>
            <path
              d="M170.667,324.267c-19.712,0-38.895-3.678-57.028-10.931c-4.344-1.758-9.336,0.375-11.085,4.753s0.384,9.344,4.753,11.093
				c20.156,8.064,41.472,12.151,63.36,12.151c94.106,0,170.667-76.561,170.667-170.667S264.772,0,170.667,0S0,76.561,0,170.667
				c0,53.675,25.498,104.329,68.352,136.508c-0.034,2.842-0.085,5.623-0.085,8.559c0,36.011,0,85.333,34.133,85.333
				c26.999,0,34.133-25.293,34.133-38.665c0-4.702-3.797-8.491-8.491-8.516H128c-4.685,0-8.491,3.789-8.533,8.474
				C119.45,364.578,118.793,384,102.4,384c-17.067,0-17.067-41.079-17.067-68.267c0-157.875,44.322-179.157,45.594-179.721
				c4.326-1.57,6.63-6.315,5.163-10.709c-1.485-4.471-6.289-6.903-10.786-5.402c-2.236,0.751-11.093,4.463-21.197,18.33
				c-1.067-3.115-1.707-6.545-1.707-10.231c0-14.114,11.486-25.6,25.6-25.6s25.6,11.486,25.6,25.6
				c0,11.733-7.936,21.939-19.294,24.815c-4.565,1.161-7.33,5.803-6.17,10.368c0.981,3.866,4.454,6.434,8.26,6.434
				c0.7,0,1.399-0.077,2.108-0.256c18.935-4.796,32.162-21.811,32.162-41.361c0-23.526-19.14-42.667-42.667-42.667
				c-23.526,0-42.667,19.14-42.667,42.667c0,10.385,3.2,19.891,8.738,27.196c-11.665,23.996-22.665,63.957-25.242,130.389
				c-32.657-28.988-51.763-70.827-51.763-114.918c0-84.693,68.907-153.6,153.6-153.6s153.6,68.907,153.6,153.6
				S255.36,324.267,170.667,324.267z"
            />
            <path
              d="M309.7,304.7l153.6,153.6c1.664,1.664,3.849,2.5,6.033,2.5c2.185,0,4.369-0.836,6.033-2.5
				c3.336-3.336,3.336-8.73,0-12.066l-153.6-153.6c-3.337-3.337-8.73-3.337-12.066,0C306.364,295.97,306.364,301.363,309.7,304.7z"
            />
            <path
              d="M509.5,412.1L355.9,258.5c-3.337-3.336-8.73-3.336-12.066,0c-3.337,3.337-3.337,8.73,0,12.066l151.1,151.1v73.267
				h-68.267v-25.6c0-4.71-3.814-8.533-8.533-8.533h-25.6v-25.6c0-4.71-3.814-8.533-8.533-8.533h-25.6v-25.6
				c0-4.71-3.814-8.533-8.533-8.533h-30.601l-48.7-48.7c-3.337-3.337-8.73-3.337-12.066,0c-3.336,3.336-3.336,8.73,0,12.066
				l51.2,51.2c1.596,1.604,3.763,2.5,6.033,2.5h25.6v25.6c0,4.71,3.814,8.533,8.533,8.533h25.6v25.6c0,4.71,3.814,8.533,8.533,8.533
				h25.6v25.6c0,4.71,3.814,8.533,8.533,8.533h85.333c4.719,0,8.533-3.823,8.533-8.533v-85.333
				C512,415.872,511.104,413.696,509.5,412.1z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export default KeySVG;
